import { makeStyles } from '@material-ui/core';
import colors from './colors';
import themeStyle from './theme';

const contentStyles = makeStyles(theme => ({
  badge: {
    ...themeStyle.typography.smMedium,
    padding: `${theme.spacing(0.25)}px ${theme.spacing(1)}px`,
    border: `1px solid ${colors.gray[200]}`,
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  rounded: {
    borderRadius: 16
  },
  square: {
    borderRadius: 6
  },
  text: {
    padding: 0,
    border: 'none',
    background: 'none !important'
  },
  capitalize: {
    textTransform: 'capitalize'
  },
  green: {
    color: colors.success[700],
    borderColor: colors.success[200],
    '&:not(.text)': {
      backgroundColor: colors.success[50]
    }
  },
  red: {
    color: colors.error[700],
    borderColor: colors.error[200],
    backgroundColor: colors.error[50]
  },
  darkRed: {
    color: colors.error[800],
    borderColor: colors.error[300],
    backgroundColor: colors.error[100]
  },
  blue: {
    color: colors.blue[700],
    borderColor: colors.blue[200],
    backgroundColor: colors.blue[50]
  },
  grayBlue: {
    color: colors.grayBlue[700],
    borderColor: colors.grayBlue[200],
    backgroundColor: colors.grayBlue[50]
  },
  purple: {
    color: colors.purple[700],
    borderColor: colors.purple[200],
    backgroundColor: colors.purple[50]
  },
  orange: {
    color: colors.orange[700],
    borderColor: colors.orange[200],
    backgroundColor: colors.orange[50]
  },
  gray: {
    color: colors.gray[700],
    borderColor: colors.gray[200],
    backgroundColor: colors.gray[50]
  }
}));

export default contentStyles;
